import type { Step } from 'react-joyride';

export const TESORERIA_HOME_TOUR_ID = 'tesoreria-home';

type TesoreriaHomeTourFlags = {
  canReadOperations: boolean;
  canWriteOperations: boolean;
  hasModuleSwitcher: boolean;
};

export function buildTesoreriaHomeTourSteps({
  canReadOperations,
  canWriteOperations,
  hasModuleSwitcher,
}: TesoreriaHomeTourFlags): Step[] {
  const steps: Step[] = [];

  if (hasModuleSwitcher) {
    steps.push({
      target: '[data-tour="module-switcher"]',
      title: 'Cambia de módulo',
      content: 'Desde aquí puedes moverte entre Tesorería, Membresías y Logística.',
      placement: 'right',
      skipBeacon: true,
    });
  }

  steps.push({
    target: '[data-tour="treasury-home-intro"]',
    title: 'Tu flujo de trabajo',
    content:
      'Tesorería sigue un flujo simple: registra el movimiento, clasifícalo, concilia contra el banco y analiza los resultados.',
    placement: 'bottom',
    skipBeacon: !hasModuleSwitcher,
  });

  if (canWriteOperations) {
    steps.push({
      target: '[data-tour="treasury-home-register"]',
      title: 'Registra un movimiento',
      content:
        'Elige el tipo de operación para registrar un depósito, retiro, transferencia u otro movimiento. Las opciones se ordenan según lo que más usa tu organización.',
      placement: 'bottom',
    });
  }

  if (canReadOperations) {
    steps.push({
      target: '[data-tour="treasury-home-tool-movements"]',
      title: 'Consulta movimientos',
      content: 'Revisa ingresos, egresos, rubros y comprobantes de cualquier cuenta.',
      placement: 'top',
    });
  }

  if (canWriteOperations) {
    steps.push({
      target: '[data-tour="treasury-home-tool-import"]',
      title: 'Importa tu estado de cuenta',
      content:
        'Carga un archivo bancario (Excel, CSV, PDF o imagen) para clasificar y aplicar varios movimientos a la vez.',
      placement: 'top',
    });
  }

  steps.push({
    target: '[data-tour="help-button"]',
    title: '¿Necesitas repasar esto?',
    content: 'Puedes volver a ver esta guía cuando quieras desde este botón.',
    placement: 'left',
  });

  return steps;
}
